import React from 'react';
import UserStateInterface from '../types/userState';
const UserStateContext = React.createContext<UserStateInterface>({});
export default UserStateContext;
